"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const homefilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-homefilled` : '') + (description ? ` desc-homefilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-homefilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-homefilled"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_12940_4586)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6.5c.26-.15.6-.12.84.08l11 9a.75.75 0 1 1-.95 1.16l-1.5-1.43V21.2c0 .6-.22 1.19-.62 1.63-.41.44-.98.7-1.58.7h-4.36a.75.75 0 0 1-.75-.75V15.6a.1.1 0 0 0 0-.04l-3.2.03v7.22a.75.75 0 0 1-.76.75H5.2a2.2 2.2 0 0 1-1.58-.7A2.4 2.4 0 0 1 3 21.21V9.27l-1.56 1.47a.75.75 0 0 1-.95-1.16l11-9 .1-.08Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.6.5c.26-.16.6-.13.84.07l11 9a.75.75 0 1 1-.95 1.16L11.96 2.1 1.44 10.73a.75.75 0 1 1-.95-1.16l11-9 .1-.08Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_12940_4586"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = homefilled;